import * as Yup from 'yup';

import { VALIDATIONS_ERROR } from '~constants/index';
import { SettlementBillingItemMetaData } from '~services/billingItem/types';

export const FIELDS_NAME = {
  BATCH_NUMBER: 'batchNumber',
  ADJUSTMENT_CONCEPT: 'adjustmentConcept',
  ADJUSTMENT_AMOUNT: 'adjustmentAmount',
  LEGAL_NOTE: 'legalNote',
} as const;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getInitialValues = (metadata: SettlementBillingItemMetaData) => ({
  [FIELDS_NAME.BATCH_NUMBER]: String(metadata.lotCounter ?? ''),
  [FIELDS_NAME.ADJUSTMENT_CONCEPT]: '',
  [FIELDS_NAME.ADJUSTMENT_AMOUNT]: '',
  [FIELDS_NAME.LEGAL_NOTE]: metadata.footerNotes ?? '',
});

export const validationSchema = Yup.object().shape({
  [FIELDS_NAME.BATCH_NUMBER]: Yup.string().required(VALIDATIONS_ERROR.REQUIRED),
  [FIELDS_NAME.ADJUSTMENT_CONCEPT]: Yup.string().notRequired(),
  [FIELDS_NAME.ADJUSTMENT_AMOUNT]: Yup.string().notRequired(),
  [FIELDS_NAME.LEGAL_NOTE]: Yup.string().notRequired(),
});
